import { useEffect, useState } from 'react'
import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import TransformBanner from '@sections/TransformBanner'
import MetaInfo from '@common/MetaInfo'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AI_STRATEGY_CONSULTING)

const AI_Strategy = [
  { icon: 'fa-solid fa-shield-halved',      title: 'Identify AI opportunities with genuine business potential',         },
  { icon: 'fa-solid fa-arrows-up-to-line',  title: 'Avoid fragmented or unnecessary AI investments',            },
  { icon: 'fa-solid fa-coins',              title: 'Align AI initiatives with business objectives', },
  { icon: 'fa-solid fa-bolt',               title: 'Understand technology and data requirements',     },
  { icon: 'fa-solid fa-gauge-high',         title: 'Prioritize initiatives based on value and feasibility',   },
  { icon: 'fa-solid fa-seedling',           title: 'Build a scalable foundation for future AI adoption',      },
]
const AI_OBJECTIVES = [
  { icon: 'fa-solid fa-magnifying-glass-chart', title: 'Identify AI Opportunities',    text: 'Discover where AI can improve processes, products, customer experiences, and business operations.' },
  { icon: 'fa-solid fa-route',                  title: 'Define Your AI Roadmap',       text: 'Prioritize AI initiatives based on business value, feasibility, data readiness, and technology requirements.' },
  { icon: 'fa-solid fa-microchip',              title: 'Choose the Right AI Approach', text: 'Evaluate the right combination of AI models, platforms, data, automation, Generative AI, and other emerging technologies.' },
  { icon: 'fa-solid fa-clipboard-check',        title: 'Prepare for AI Adoption',      text: 'Assess your existing technology, data, infrastructure, security, and organizational readiness for AI.' },
  { icon: 'fa-solid fa-layer-group',            title: 'Plan Scalable AI Solutions',   text: 'Create a practical strategy for developing, integrating, deploying, and scaling AI capabilities.' },
  { icon: 'fa-solid fa-star',                   title: 'Dummy Heading',                text: 'Dummy text goes here for now. It will be replaced with the final content later.' },
]


// Section 2 
const AI_SERVICES = [
  {
    icon: 'fa-cloud',
    title: 'AI Opportunity Assessment',
    desc: 'Identify high-value opportunities where AI can deliver measurable business impact.',
  },
  {
    icon: 'fa-building',
    title: 'AI Readiness Assessment',
    desc: ' Evaluate your data, technology, infrastructure, processes, and organizational readiness.',
  },
  {
    icon: 'fa-mobile-screen-button',
    title: 'AI Roadmap & Strategy',
    desc: 'Define priorities, initiatives, timelines, and technology direction for AI adoption.',
  },
  {
    icon: 'fa-rocket',
    title: 'Generative AI Strategy',
    desc: 'Identify practical applications of LLMs, GenAI, conversational AI, and intelligent automation.',
  },
  {
    icon: 'fa-arrows-rotate',
    title: 'AI Product Strategy',
    desc: 'Explore how AI can enhance existing products or enable new digital products and services.',
  },
  {
    icon: 'fa-plug',
    title: 'AI Technology Evaluation',
    desc: 'Assess AI models, platforms, tools, architectures, and technology options.',
  },
   {
    icon: 'fa-plug',
    title: 'AI Governance & Risk Advisory',
    desc: 'Establish practical approaches for responsible, secure, and governed AI adoption.',
  },
]

function FeatureList({ items, offset, position }) {
  return (
    <ol
      className={`feature-radial__list feature-radial__list--${position}`}
      role="list"
      start={offset + 1}
    >
      {items.map((item, i) => (
        <li
          key={item.title}
          className="feature-radial__item"
          data-aos="fade-up"
          data-aos-delay={i * 80}
        >
          {/* <span className="icon-circle feature-radial__icon" aria-hidden="true">
            <i className={item.icon} />
          </span> */}
          <div>
            <h3 className="ai-card-title">{item.title}</h3>
            <p>{item.text}</p>
          </div>
          {/* <span className="feature-radial__number" aria-hidden="true">
            {String(offset + i + 1).padStart(2, '0')}
          </span> */}
        </li>
      ))}
    </ol>
  )
}

/* Centred image flanked by two numbered lists; stacks vertically on small screens */
function FeatureRadial({ items, image, imageAlt = '' }) {
  const half = Math.ceil(items.length / 2)

  return (
    <div className="feature-radial">
      <figure className="feature-radial__media" data-aos="zoom-in">
        {/* <img src={image} alt={imageAlt}  loading="lazy" decoding="async" /> */}
      </figure>
      <FeatureList items={items.slice(0, half)} offset={0} position="start" />
      <FeatureList items={items.slice(half)} offset={half} position="end" />
    </div>
  )
}

const STRATEGY_STEPS = [
  'Discover', '→', 'Assess', '→', 'Prioritize', '→', 'Strategize', '→', 'Roadmap',
]

export default function AIStrategyConsulting() {
   const [sectionVisible, setSectionVisible] = useState(false)
  const [visibleSteps, setVisibleSteps] = useState(0)
  const [isExiting, setIsExiting] = useState(false)

  useEffect(() => {
    const section = document.getElementById('strengths')
    if (!section) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setSectionVisible(true)
          observer.disconnect()
        }
      },
      { threshold: 0.25 }
    )

    observer.observe(section)
    return () => observer.disconnect()
  }, [])

  // useEffect(() => {
  //   if (!sectionVisible) return

  //   const isComplete = visibleSteps === STRATEGY_STEPS.length
  //   const timer = setTimeout(
  //     () => setVisibleSteps(isComplete ? 0 : visibleSteps + 1),
  //     isComplete ? 1800 : 500
  //   )

  //   return () => clearTimeout(timer)
  // }, [sectionVisible, visibleSteps])
useEffect(() => {
  if (!sectionVisible) return

  const isComplete = visibleSteps === STRATEGY_STEPS.length
  let delay = 500
  let next = () => setVisibleSteps((count) => count + 1)

  if (isComplete && !isExiting) {
    delay = 1800
    next = () => setIsExiting(true)
  } else if (isExiting) {
    delay = 400
    next = () => {
      setVisibleSteps(0)
      setIsExiting(false)
    }
  }

  const timer = setTimeout(next, delay)
  return () => clearTimeout(timer)
}, [sectionVisible, visibleSteps, isExiting])
  return (
    <>
    {/* <MetaInfo
        title="AI Strategy Consulting | CruxBytes"
        description="Identify AI opportunities, assess readiness and build a practical roadmap for AI adoption with AI strategy consulting from CruxBytes."
        keywords="AI strategy consulting, AI roadmap, AI readiness assessment, generative AI strategy, AI opportunity assessment, AI governance, CruxBytes"
      /> */}
      <MetaInfo
      title={`${label} ${SITE.metaTagPostText}`} 
      description={metaDesc}
      keywords=""
      />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- Application Consulting -</div> */}
             <Breadcrumb />
             <h1 data-aos="fade-up" data-aos-delay={100}>
              {/* AI Strategy Consulting */}
              {label}
             </h1>
             <p className="page-subtitle" data-aos="fade-up" data-aos-delay={200}>
             {/* Navigate your AI journey with expert strategy, planning, and technology guidance. */}
             {pageDesc}
             </p>             
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right" data-aos="fade-up" data-aos-delay={300}>
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
<section className=" section-py bg-peach" style={{ paddingBottom:"0.1rem" }} >
      <div className="container-fluid">
         <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div className="bgs-row-content">           
           
            <p className="text-center" >
            AI can create significant opportunities across products, operations, customer experience, and decision-making — but successful adoption starts with knowing where and how to apply it. CruxBytes helps organizations identify meaningful AI opportunities, evaluate their potential, define the right technology approach, and build a practical roadmap for AI adoption.
            </p>
            
          </div>
        </div>
        <div className="text-center" data-aos="fade-up">
          <h6 className="text-highlight-light">
           Turn AI Opportunities into a Clear Business Strategy
          </h6>
        </div>
             <div className="section-header" data-aos="fade-up">
          <p className="section-subheading">
            Our AI strategy consulting helps you move beyond experimentation and focus on AI initiatives that align with your business objectives.
          </p>
        </div></div></section>
         {/* section 1 */}
  <section className=" section-py ai-bgs-section--tint" style={{backgroundColor:'var(--bg-peach)'}} >
      <div className="container-fluid">
             

        {/* Row 2 — */}
        {/*  */}
        <FeatureRadial
          items={AI_OBJECTIVES}
          image="/assets/images/ai-objectives.jpg"
          imageAlt="AI strategy objectives illustration"
        />
      </div>
    </section>
   



  {/* ── Section 2 */}
        <section className="section-py" aria-labelledby="egovernance-partner-heading" style={{ borderRadius:"0" }}>
          

          <div className="container">
           <div className="" data-aos="fade-up">
              <div className="section-card__content ">
                <h2 className='text-center' id="egovernance-partner-heading">
                  Our AI Strategy Consulting Services
                </h2>
               
              </div>

            <div className="wcs-grid">
              {AI_SERVICES.map((item, i) => (
                <div
                  key={item.title}
                  className="wcs-card "
                  data-aos="fade-up"
                  data-aos-delay={i * 80}
                >
                  {i > 0 && <div className="sc-code-divider" aria-hidden="true" />}
                  {/* <i className={`fa-solid ${item.icon} wcs-icon`} aria-hidden="true" /> */}
                  <h3 className="text-secondary wcs-title">{item.title}</h3>
                  <p className="text-secondary wcs-desc">{item.desc}</p>
                </div>
              ))}
            </div>
            </div>
          </div>
        </section>

{/* Section3 */}
 <section
      id="strengths"
      className="about-us-section section-py  bg-linear-gradient-light "
      aria-labelledby="strengths-heading"
      data-aos="fade-up"
    >   <div className='container'> 
      <h2 id="strengths-heading" className="section-heading ">A Practical Approach to AI Adoption</h2>
  <h4 className={`text-italic strategy-animation${isExiting ? ' strategy-animation--exit' : ''}`}>
  {STRATEGY_STEPS.slice(0, visibleSteps).map((step, index) => (
    <span key={`${step}-${index}`} className="strategy-animation__item">
      {step}
    </span>
  ))}
</h4>
      <p className="about-us-section-body">
        We begin by understanding your business objectives and challenges, assess where AI can create meaningful value, prioritize opportunities, and develop a roadmap aligned with your technology and business environment.
      </p>
      <div className="sc-tm-row pt-4">

      <div className="sc-tm-content" data-aos="fade-left">
       
     <h2 id="impact-heading" >
            <span className="impact-heading-dark">Why Businesses Choose</span>
            <span className="impact-heading-light">AI Strategy Consulting</span>
          </h2>
      </div>
      <div  data-aos="fade-right">
        <div className="contact-form-wrap">
          {AI_Strategy.map((card, i) => (
            <ul
              key={card.title}             
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 80}
            >             
              <li className='d-flex'>                
                {/* <i class="fa-regular fa-heart wcs-icon" aria-hidden="true"></i> */}
                <i className="fa-regular fa-heart check-list-icon" aria-hidden="true" />
                
              <p className="wcs-title text-secondary ps-3">{card.title}</p>
              {/* <p className="wcs-desc">{card.desc}</p> */}
              </li>
            </ul>
          ))}
        </div>
      </div>

    </div>
    </div>  
    </section>

    {/* Section4 */}
      <section className=" section-py" aria-labelledby="bgs-reach-heading3">
      <div className="container">
        <div className="text-center" data-aos="fade-up">
          <h2 id="bgs-reach-heading3">
           AI Strategy That Leads to Action
          </h2>
        </div>     

        {/* Row 2 — */}
        <div className="bgs-row bgs-row--text-only" data-aos="fade-up">
          <div >           
           
            <p className="section-px2" >
             A successful AI strategy should do more than identify possibilities. It should provide a clear direction for what to build, why to build it, and how to move forward.
            </p>
            <p className="section-px2">
              With experience across software engineering, data, cloud, Generative AI, automation, and enterprise technology, CruxBytes brings business objectives and technology decisions together to create practical AI strategies.
            </p>            
          </div>
        </div>
      <div>      
      </div>
      </div>
    </section>
         <TransformBanner />
         </main>
         </>
  )
}